import { z } from "zod";

import { Template } from "~/tools/template";

import { DEFAULT as DEFAULT_QUERY, type Spec as QuerySpec } from "../../components/widget-form/query/spec";
import { partial, tuple } from "../_decoders";
import { Encoder } from "../_encoder";

const templateDecoder = z
	.string()
	.transform((source) => Template<null>(source))
	.optional()
	.catch(undefined);

const decoder = tuple([templateDecoder, templateDecoder, templateDecoder]).transform(
	([promql = Template(""), alias, minStep]) => ({ promql, ...partial({ alias, minStep }) }),
);

function encoder(query: QuerySpec): Encoder {
	return Encoder.tuple(
		Encoder.primitive(query.promql.source, DEFAULT_QUERY.promql.source),
		Encoder.primitive(query.alias?.source, DEFAULT_QUERY.alias.source),
		Encoder.primitive(query?.minStep?.source, DEFAULT_QUERY.minStep.source),
	);
}

export { decoder, encoder };
